// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-container,
.swiper-wrapper,
.swiper-slide {
  background: #000000;
}
@media only screen and (max-width: 460px) {
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    height: 100vh;
  }
}
@media only screen and (min-width: 460px) and (max-width: 1450px) {
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    height: 760px;
  }
}
@media only screen and (min-width: 1450px) {
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    height: 1020px;
  }
}

@media only screen and (min-width: 460px) {
  .swiper-zoom-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}

.swiper-slide img {
  position: relative;
  display: block;
}
@media only screen and (max-width: 460px) {
  .swiper-slide img {
    margin-top: 30%;
    margin-bottom: 50%;
  }
}

.close-button {
  position: fixed;
  top: 20px;
  right: 15px;
}

.modalPage {
  background: rgba(0, 0, 0, 0.5) !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
